import { render, staticRenderFns } from "./ImpactMeasuresPage.vue?vue&type=template&id=29e6b6b6&scoped=true&"
import script from "./ImpactMeasuresPage.vue?vue&type=script&lang=js&"
export * from "./ImpactMeasuresPage.vue?vue&type=script&lang=js&"
import style0 from "./ImpactMeasuresPage.vue?vue&type=style&index=0&id=29e6b6b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e6b6b6",
  null
  
)

export default component.exports